import {TableauRecherches} from "./composants/TableauRecherches.js";
import {Recherche} from "./Recherche.js";
import {FenêtreSurgissante} from "./composants/FenêtreSurgissante.js";
import {ÉvénementsGTM} from "./constantes.js";
import {GestionnaireURL} from "./GestionnaireURL.js";

export class GestionnaireFavoris {

    static Événements = Object.freeze(
        {
            "RECHERCHE_FAVORIS_MODIFIÉS": "recherche-favoris-modifiés",
            "RECHERCHE_FAVORIS_MAXITEMS": "recherche-favoris-maxitems",
        }
    );

    static MAX_ITEMS = 50;

    constructor(constructeurDeRecherche, bd) {

        this.bd = bd;
        this.cr = constructeurDeRecherche;

        this.conteneur = document.getElementById("favorisRecherche");

        if(this.conteneur) {
            this.tableau = this.conteneur.querySelector(TableauRecherches.nom);

            document.addEventListener(TableauRecherches.Événements.RECHERCHE_FAVORI_AJOUTER, (e) => this.ajouteRechercheFavorite(e));
            document.addEventListener(TableauRecherches.Événements.RECHERCHE_FAVORI_SUPPRESSION, (e) => this.supprimeRechercheFavorite(e));
            document.addEventListener(TableauRecherches.Événements.RECHERCHE_FAVORI_PARTAGE, (e) => this.partageRechercheFavorite(e));
            document.addEventListener(TableauRecherches.Événements.RECHERCHE_FAVORI_EXÉCUTER, (e) => this.exécuteRechercheFavorite(e));
            document.addEventListener(TableauRecherches.Événements.RECHERCHE_FAVORI_VIDER, (e) => this.viderFavoris(e));
            document.addEventListener(TableauRecherches.Événements.RECHERCHE_FAVORI_RENOMMER, (e) => this.renommer(e.detail));

            customElements.get(FenêtreSurgissante.nom) || customElements.define(FenêtreSurgissante.nom, FenêtreSurgissante);
            this.fenêtreSurgissanteÉlément = new FenêtreSurgissante();
            this.conteneur.appendChild(this.fenêtreSurgissanteÉlément);

            this.getRecherches().then((t) => {
                this.tableau.affiche(t);
            });
        }

    }

    getRecherches() {
        return this.bd.recherchesFavorites.orderBy('ts').reverse().toArray();
    }

    getRechercheFavorite(recherche) {
        return this.bd.recherchesFavorites.get({hash: recherche.hash});
    }

    getHashFavoris() {
        return this.bd.recherchesFavorites.orderBy('hash').keys();
    }

    ajouteRechercheFavorite(e) {
        // Ne pas ajouter au favori si s'y trouve déjà
        this.getRechercheFavorite(e.detail.recherche).then((recherche) => {
            if (!recherche) {
                this.bd.recherchesFavorites.count()
                    .then((nbFavorisItems) => {
                        if (nbFavorisItems >= GestionnaireFavoris.MAX_ITEMS) {
                            this.envoieÉvénementMaxItems(`Nombre maximum de favoris atteint (${GestionnaireFavoris.MAX_ITEMS}) !`);
                        } else
                            this.bd.recherchesFavorites.put(Object.assign(e.detail.recherche, {ts: Date.now()}))
                                .then(() => {
                                    this.getRecherches().then((t) => {
                                        this.tableau.affiche(t);
                                    });

                                    this.envoieÉvénementFavorisModifiés();

                                });

                        envoyerÉvénementGTM(ÉvénementsGTM.CLIC.code, ÉvénementsGTM.CLIC.actions.MOTS_FAVORIS_AJOUTER, nbFavorisItems + 1);

                    });
            }
        })

    }

    supprimeRechercheFavorite(e) {
        this.bd.recherchesFavorites.where('hash').equals(e.detail.recherche.hash)
            .delete().then((nbSupp) => {

            envoyerÉvénementGTM(ÉvénementsGTM.CLIC.code, ÉvénementsGTM.CLIC.actions.MOTS_FAVORIS_SUPPRIMER, nbSupp);

            this.getRecherches().then((t) => {
                this.tableau.affiche(t);
                document.dispatchEvent(new CustomEvent(GestionnaireFavoris.Événements.RECHERCHE_FAVORIS_MODIFIÉS, {
                    bubbles: true,
                    composed: true
                }))
            });
        });
    }

    viderFavoris(e) {
        this.bd.recherchesFavorites.clear();
        this.getRecherches().then((t) => {
            this.tableau.affiche(t);
            this.envoieÉvénementFavorisModifiés();
        });
    }

    renommer(rechercheInfo) {
        this.bd.recherchesFavorites.update(rechercheInfo.recherche.hash, {nom: rechercheInfo.nouveauNom});
        this.getRechercheFavorite(rechercheInfo.recherche).then((recherche) => {
            this.tableau.majNomRecherche(recherche);
        });

        envoyerÉvénementGTM(ÉvénementsGTM.CLIC.code, ÉvénementsGTM.CLIC.actions.MOTS_FAVORIS_RENOMMER, rechercheInfo.nouveauNom);

    }

    envoieÉvénementFavorisModifiés() {
        document.dispatchEvent(new CustomEvent(GestionnaireFavoris.Événements.RECHERCHE_FAVORIS_MODIFIÉS, {
            bubbles: true,
            composed: true
        }))
    }

    envoieÉvénementMaxItems(message) {
        document.dispatchEvent(new CustomEvent(GestionnaireFavoris.Événements.RECHERCHE_FAVORIS_MAXITEMS, {
            detail: {message: message,},
            bubbles: true,
            composed: true
        }))
    }

    async partageRechercheFavorite(e) {
        // recharger depuis Dexie car peut avoir été renommée
        const recherche = await this.getRechercheFavorite(e.detail.recherche);

        const {rechercheSérialisée, rechercheURL} = this.getRechercheSérialisée(recherche);
        try {
            await navigator.clipboard.writeText(rechercheURL.href);
            this.fenêtreSurgissanteÉlément.informe("URL de la recherche favorite copiée dans le presse-papier.");
        } catch (erreur) {
            this.fenêtreSurgissanteÉlément.avertis(erreur.message);
        }
    }

    getRechercheSérialisée(recherche) {
        const rechercheSérialisée = Recherche.sérialise(recherche);
        const rechercheCompressée = LZString.compressToEncodedURIComponent(rechercheSérialisée);
        const nouvelleURL = GestionnaireURL.getRechercheURL(recherche.nom, rechercheCompressée);
        return {rechercheSérialisée, rechercheURL: nouvelleURL};
    }

    async exécuteRechercheFavorite(e) {
        // recharger depuis Dexie car peut avoir été renommée
        const recherche = await this.getRechercheFavorite(e.detail.recherche);

        this.cr.chargeNouvelleRecherche(new Recherche(recherche.critères, recherche.options, recherche.nom));
    }


}
